import { render, staticRenderFns } from "./distribution_chart.vue?vue&type=template&id=02b0065e&"
import script from "./distribution_chart.vue?vue&type=script&lang=js&"
export * from "./distribution_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports